import axios from "../config";

export const getClientProfiles = () => {
  return axios.get("/client-profile?sort=preferredName:ASC");
};

export const updateClientProfileSummary = (clientProfileId, summary) => {
  return axios.put(`/client-profile/summary/${clientProfileId}`, { summary });
};
